<div class="box-form-ui container-pse">
  <header>
    <h1>Ahora vas a abonar la plata a tu CDT</h1>
    <picture>
      <source
        [srcset]="
          assetsUrl +
          '/images/cdt/illustrations/pse/logo-pse@3x.jpg 3x, ' +
          assetsUrl +
          '/images/cdt/illustrations/pse/logo-pse@2x.jpg 2x, ' +
          assetsUrl +
          '/images/cdt/illustrations/pse/logo-pse.jpg    1x'
        "
      />
      <img
        [src]="assetsUrl + '/images/cdt/illustrations/pse/logo-pse.jpg'"
        alt=""
      />
    </picture>
  </header>

  <app-alert
    margin="30px 0 30px 0"
    msg="No olvides tener disponible el dinero en tu cuenta y revisa que los límites de transacciones por PSE en tu otro banco te permitan realizar la transacción"
  ></app-alert>

  <div class="memory-data">
    <p class="product-number">
      <strong>CDT Digital </strong>No. {{ cdtNumber }}
    </p>

    <div class="investment-data">
      <p class="totalCDT">
        Al vencimiento de tu CDT recibirás:
        <strong [innerHTML]="totalCDT | currencyFormatSimple"></strong>
      </p>
      <span class="investment-data-divider mobile"></span>
      <div class="dataCDT">
        <div id="investment-data-box-1" class="investment-data-box">
          <h2 class="first-subtitle">Inversión</h2>
          <p class="info investment investment-amount">
            {{ simulationData.amount }}<span>.00</span>
          </p>
        </div>

        <span class="investment-data-divider"></span>

        <div
          id="investment-data-box-2"
          class="investment-data-box secondary-item"
        >
          <h2 class="other-subtitle">Plazo</h2>
          <p class="info investment others">{{ simulationData.days }} días</p>
        </div>

        <span class="investment-data-divider"></span>

        <div
          id="investment-data-box-3"
          class="investment-data-box secondary-item"
        >
          <h2 class="other-subtitle">Tasa</h2>
          <p class="info investment others">{{ simulationData.rate }} %</p>
        </div>
      </div>
    </div>
  </div>

  <form
    id="PseForm"
    class="pse-form"
    [formGroup]="pseForm"
    autocomplete="off"
    (ngSubmit)="onSubmit()"
  >
    <p class="label question">¿De qué banco traerás tu plata?</p>

    <mat-form-field appearance="fill" id="Bank" class="bank">
      <mat-label class="label">Selecciona</mat-label>

      <mat-select
        appSelectOverlayPosition
        disableOptionCentering
        formControlName="bank"
      >
        <mat-option *ngFor="let bank of banks" [value]="bank.bankId">
          {{ bank.name }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="pseForm.controls['bank'].hasError('required')">
        {{ ERROR_REQUIRED_TEXT }}
      </mat-error>
    </mat-form-field>

    <mat-radio-group class="type-person-radio" formControlName="typePerson">
      <mat-label class="radio-label">
        <span class="label label-type-person">Tipo de persona</span>
      </mat-label>

      <div class="group-radio">
        <mat-radio-button
          *ngFor="let typePerson of typePersonValues"
          [value]="typePerson.value"
          >{{ typePerson.text }}</mat-radio-button
        >
      </div>
    </mat-radio-group>

    <section
      class="return-money"
      formGroupName="returnMoney"
      *ngIf="groupReturnMoney.enabled"
    >
      <h3>
        En caso de que el <strong>CDT no se pueda abrir</strong>, necesitamos
        los siguientes datos para hacerte la devolución de la plata
      </h3>

      <button type="button" class="open-dialog-button" (click)="openDialog()">
        ¿Por qué no se podría abrir el CDT?
      </button>

      <p class="label question">Banco en donde deseas la devolución</p>

      <mat-form-field appearance="fill" id="ReturnBank" class="return-bank">
        <mat-label class="label">Selecciona tu banco</mat-label>

        <mat-select
          appSelectOverlayPosition
          disableOptionCentering
          formControlName="returnBank"
        >
          <mat-option *ngFor="let bank of banks" [value]="bank.bankId">
            {{ bank.name }}
          </mat-option>
        </mat-select>

        <mat-error
          *ngIf="pseForm.get('returnMoney.returnBank').hasError('required')"
        >
          {{ ERROR_REQUIRED_TEXT }}
        </mat-error>
      </mat-form-field>

      <mat-radio-group class="account-type" formControlName="accountType">
        <mat-label class="radio-label">
          <span class="label">Tipo de cuenta</span>
        </mat-label>

        <div class="group-radio">
          <mat-radio-button
            *ngFor="let accountType of accountTypeValues"
            [value]="accountType.value"
          >
            {{ accountType.text }}
          </mat-radio-button>
        </div>
      </mat-radio-group>

      <mat-form-field appearance="fill">
        <mat-label class="label">Número de cuenta</mat-label>
        <input
          matInput
          appOnlyNumbers
          maxlength="17"
          formControlName="accountNumber"
          id="AccountNumber"
        />
        <mat-error
          *ngIf="pseForm.get('returnMoney.accountNumber').hasError('required')"
        >
          {{ ERROR_REQUIRED_TEXT }}
        </mat-error>

        <mat-error
          *ngIf="
            !pseForm.get('returnMoney.accountNumber').hasError('required') &&
            pseForm.get('returnMoney.accountNumber').hasError('minlength')
          "
        >
          Ingresa un número de cuenta válido.
        </mat-error>

        <mat-error
          *ngIf="
            !pseForm.get('returnMoney.accountNumber').hasError('required') &&
            !pseForm.get('returnMoney.accountNumber').hasError('minlength') &&
            pseForm.get('returnMoney.accountNumber').hasError('maxlength')
          "
        >
          Ingresa un número de cuenta válido.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" id="DocumentType">
        <mat-label class="label">Tipo de documento</mat-label>

        <mat-select
          appSelectOverlayPosition
          disableOptionCentering
          formControlName="documentType"
        >
          <mat-option
            *ngFor="let documentType of documentTypeValues"
            [value]="documentType.value"
          >
            {{ documentType.text }}
          </mat-option>
        </mat-select>

        <mat-error
          *ngIf="pseForm.get('returnMoney.documentType').hasError('required')"
        >
          {{ ERROR_REQUIRED_TEXT }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label class="label">Número de documento</mat-label>
        <input
          matInput
          appOnlyNumbers
          maxlength="10"
          formControlName="documentNumber"
          id="DocumentNumber"
        />
        <mat-error
          *ngIf="pseForm.get('returnMoney.documentNumber').hasError('required')"
        >
          {{ ERROR_REQUIRED_TEXT }}
        </mat-error>

        <mat-error
          *ngIf="
            !pseForm.get('returnMoney.documentNumber').hasError('required') &&
            pseForm.get('returnMoney.documentNumber').hasError('minlength')
          "
        >
          Este campo debe tener mínimo 4 caracteres.
        </mat-error>
        <mat-error
          *ngIf="
            !pseForm.get('returnMoney.documentNumber').hasError('required') &&
            !pseForm.get('returnMoney.documentNumber').hasError('minlength') &&
            pseForm.get('returnMoney.documentNumber').hasError('maxlength')
          "
        >
          Este campo debe tener máximo 10 caracteres.
        </mat-error>
      </mat-form-field>
    </section>

    <div class="box-btn-submit">
      <button
        class="avv-btn-primary"
        type="submit"
        [disabled]="!isValidForm()"
        id="SubmitPseForm"
      >
        Ir a PSE 
      </button>
    </div>
  </form>
</div>
